export default {
  left: {
    group: 'My group: ',
    location: 'Schedule location: ',
    description: 'Schedule description: ',
    scoreChart: 'Score sheet: ',
    scoreChartDescription: 'Score sheet description: ',
  },
  logout: 'logout',
  right: {
    title: 'Task list',
    incomplete: 'Incomplete: {number} person | Incomplete: {number} people',
    complete: 'Completed: {number} person | Completed: {number} people',
    signature: 'Signature',
    searchPlaceholder: 'Name',
    mobileTitle: 'Task: {incomplete} person incomplete   {complete} person completed',
  },
  table: {
    operation: 'Actions',
    status: 'Status',
    name: 'Name',
    number: 'No. of people',
    incomplete: 'Incomplete',
    time: 'Interview time',
    people: '{number} person | {number} people',
    preparation: 'Ready for entry',
    tips: 'Prompted',
    revert: 'Revert',
    view: 'Enter',
    signature: 'Signature',
    signed: 'Signed',
    viewDetail: 'View details',
    preview: 'Result preview',
  },
  nodata: 'No task',
  toEntriesMsg: 'The interview has finished scoring',
  401: 'Login expired, please login again',
  status: {
    waiting: 'Not started',
    interviewing: 'Interviewing',
    complete: 'Finished',
    default: 'Something went wrong',
  },
  signOut: {
    msg: 'Are you sure to opt out of the interview scoring system?',
    cancel: 'Cancel the exit',
  },
};
